import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { BarChart3, TrendingUp, Package, DollarSign, PieChart, Download } from "lucide-react";

const reportCards = [
  { title: "Sales Reports", desc: "Revenue, quotes, invoices by period", icon: TrendingUp, path: "/reports/sales", color: "text-blue-600 bg-blue-50" },
  { title: "Purchase Reports", desc: "Purchase orders, supplier spending", icon: DollarSign, path: "/reports/purchases", color: "text-green-600 bg-green-50" },
  { title: "Inventory Reports", desc: "Stock levels, movement, valuation", icon: Package, path: "/reports/inventory", color: "text-amber-600 bg-amber-50" },
  { title: "Financial Reports", desc: "Aging, statements, cash flow", icon: BarChart3, path: "/reports/financial", color: "text-purple-600 bg-purple-50" },
  { title: "Profit Analysis", desc: "Margins, cost analysis, trends", icon: PieChart, path: "/reports/profit", color: "text-pink-600 bg-pink-50" },
  { title: "Export Data", desc: "Export data to CSV or Excel", icon: Download, path: "/reports/export", color: "text-gray-600 bg-gray-100" },
];

export default function ReportsHubPage() {
  const navigate = useNavigate();
  return (
    <div data-testid="reports-hub-page">
      <div className="mb-6">
        <h1 className="font-heading font-bold text-2xl text-[#1F2937]">Reports</h1>
        <p className="text-sm text-gray-500 mt-1">Analytics and reporting tools</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {reportCards.map(r => (
          <Card key={r.path} data-testid={`report-card-${r.title.toLowerCase().replace(/\s+/g, "-")}`} className="border rounded-sm cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate(r.path)}>
            <CardContent className="p-5">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${r.color}`}><r.icon className="w-5 h-5" /></div>
              <h3 className="font-semibold text-[#1F2937]">{r.title}</h3>
              <p className="text-xs text-gray-500 mt-1">{r.desc}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
